<h2 class="ao-heading-300 ao-bold ao-nowrap">{{ heading }}</h2>
@for (claimRep of claimReps; track claimRep; let i = $index) {
	<div class="ao-top-32">
		@if (claimRep.lastName) {
			<p>{{ claimRep.nickName ?? claimRep.firstName | titlecase }} {{ claimRep.lastName | titlecase }}</p>
		}
		@for (responsibility of getResponsibilities(i); track responsibility) {
			<p>{{ responsibility }}</p>
		}
		<p class="ao-top-16">{{ claimRep.claimBranch?.name | titlecase }}</p>
		<a
			href="tel:{{ claimRep.workPhoneNumber ?? claimRep.claimBranch?.tollFreePhoneNumber | formatTelLink }}"
			class="ao-newline ao-link ao-top-16"
		>
			<i class="fa fa-phone ao-right-8" aria-label="contact phone number:"></i
			>{{ claimRep.workPhoneNumber ?? claimRep.claimBranch?.tollFreePhoneNumber }}
		</a>
		<a
			href="mailto:{{ claimRep.claimBranch?.emailAddress | lowercase }}?subject=Claim%20%23%20{{
				claim.claimNumber
			}}"
			class="ao-newline ao-link ao-top-16"
		>
			<i class="fa fa-envelope ao-right-8" aria-label="contact email address:"></i
			>{{ claimRep.claimBranch?.emailAddress | lowercase }}
		</a>
	</div>
}
